import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-student-grievance',
    templateUrl: './student-grievance.component.html',
    styleUrls: ['./student-grievance.component.scss']
})
export class StudentGrievanceComponent implements OnInit {
    committeeMembers = [
        {
            sno: 1,
            name: 'Ms. Mehr Un Nisa',
            designation: 'Assistant Registrar (Students Care & Support Cell)',
            status: 'Chairperson'
        },
        {sno: 2, name: 'Mr. Narinder Kumar', designation: 'Assistant Registrar (Admin)', status: 'Member'},
        {sno: 3, name: 'Dr. Shreya Singh', designation: 'HOD – Agriculture', status: 'Member'},
        {sno: 4, name: 'Ms. Shweta Mishra', designation: 'Asst. Professor- Arts & Humanities', status: 'Member'},
        {sno: 5, name: 'Ms. Neha Rani', designation: 'Asst. Professor- CSE', status: 'Member'},
        {sno: 6, name: 'Ms. Pallvi', designation: 'Asst. Professor- Mathematics', status: 'Member'},
        {sno: 7, name: 'Mr. Sukhvinder Singh', designation: 'Asst. Professor- Life Sciences', status: 'Members'},
        {
            sno: 8,
            name: 'Mr. Swadhin Kumar Rout',
            designation: 'Asst. Professor- Business Mgt',
            status: 'Member Secretary'
        },
        {sno: 9, name: 'Ms. Palak (Pharmacy)', designation: 'Student', status: 'Member'},
        {sno: 10, name: 'Ms. Shruti (Pharmacy)', designation: 'Student', status: 'Member'},
        {sno: 11, name: 'Mr. Akseesh Jaggi (Civil)', designation: 'Student', status: 'Member'},
        {sno: 12, name: 'Mr. Tahir Bahsir (Pharmacy)', designation: 'Student', status: 'Member'},
        {sno: 13, name: 'Ms. Ritika (Life Sciences)', designation: 'Student', status: 'Member'},
        {sno: 14, name: 'Ms. Payal (Allied Health Sciences)', designation: 'Student', status: 'Member'},
        {
            sno: 15,
            name: 'Mr. Akash Kumar Sharma (Pharmacy)',
            designation: 'Student',
            status: 'Student Representative member'
        }
    ];

    faqs = [
        {
            question: 'What kind of issues can I raise through the grievance cell?',
            answer: 'You can raise concerns related to academics, faculty, examinations, harassment, hostel facilities, fees, or any administrative delays.\n',
            isOpen: false,
        },
        {
            question: 'How Can I Lodge a Grievance?',
            answer: 'One will need to register themselves on the university grievance portal and log in with personalized user credentials. Follow the simple steps, click on the lodge complaint button and fill out the required details, and submit the information.',
            isOpen: false,
        },
        {
            question: 'How can I file a grievance?',
            answer: 'Grievances can be submitted online via the university portal or offline by visiting the Grievance Redressal Cell in person.',
            isOpen: false,
        },
        {
            question: 'Will my identity be kept confidential?',
            answer: 'Yes. The grievance committee maintains strict confidentiality, and your identity will not be disclosed without your consent.',
            isOpen: false,
        },
        {
            question: 'How long does it take to resolve a grievance?',
            answer: 'Most grievances are resolved within 15 working days after acknowledgment. Complex issues may take slightly longer.',
            isOpen: false,
        },
        {
            question: 'What if my grievance is not resolved satisfactorily?',
            answer: 'You may escalate the matter to the higher authorities, such as the Dean or the Ombudsperson, as per the prescribed university guidelines.',
            isOpen: false,
        },
    ];

    constructor() {
    }

    ngOnInit(): void {
    }

    toggleFAQ(index: number): void {
        this.faqs = this.faqs.map((faq, i) => ({
            ...faq,
            isOpen: i === index ? !faq.isOpen : false
        }));
    }

}
